import * as Yup from 'yup';

export const SectionTemplateInfoSchema = Yup.object().shape({
  codingConfig: Yup.object()
    .shape({
      code: Yup.string().required('Code requis'),
    })
    .required('Code requis'),
  label: Yup.string().required('Libellé requis'),
});
